import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;
const maxLogSize = 200;
var axiosLogs = [];

const limitLogs = () => {
   if (axiosLogs.length > maxLogSize) {
      axiosLogs.shift();
   }
};

const logResponses = (response) => {
   let respObject = {};
   try {
      respObject["Headers"] = response.config.headers;
      respObject["Req"] = `${response.config.method.toUpperCase()} | ${response.status} | ${
         response.config.url.split(hostCloud)[1]
      }`;
      respObject["Req body"] = response.config.data;
      respObject["Response"] = response.data;

      axiosLogs.push(respObject);
   } catch {}

   limitLogs();
};

const logResponsesError = (response) => {
   let respObject = {};
   try {
      respObject["Headers"] = response.config.headers;
      respObject["Req"] = `ERROR | ${response.config.method.toUpperCase()} | ${
         response.response.status
      } | ${response.config.url.split(hostCloud)[1]}`;
      respObject["Req error"] =
         `${response?.response?.data?.message} | ${response?.response?.data?.error}`;
      respObject["Req body"] = response.config.data;
      respObject["Response"] = response.data;

      axiosLogs.push(respObject);
   } catch {}

   limitLogs();
};

// Request/response logging functionality
export const loggingInterceptor = {
   response: (response) => {
      logResponses(response);
      return response;
   },

   responseError: (error) => {
      logResponsesError(error);
      return Promise.reject(error);
   },
};

// Expose logging utilities on window for debugging
window.logs = (numberOfLogs) => {
   if (numberOfLogs === undefined) {
      numberOfLogs = 50;
   }
   const showLogs = [];
   let step = 0;
   for (let i = axiosLogs.length - 1; i > 0; i--) {
      if (step < numberOfLogs) {
         showLogs.push(axiosLogs[i]);
         step++;
      }
   }
   showLogs.reverse();
   console.log(showLogs);
   console.log(JSON.stringify(showLogs));
};

window.getLogs = () => {
   return axiosLogs;
};

window.downloadLogs = () => {
   const downloadElement = document.createElement("a");
   downloadElement.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(axiosLogs)),
   );
   downloadElement.setAttribute("download", "app-logs");
   downloadElement.style.display = "none";
   document.body.appendChild(downloadElement);
   downloadElement.click();
   document.body.removeChild(downloadElement);
};
